import { useSourcingInternalStore } from 'modules/sourcing-internal/stores/hooks';
import { useShallow } from 'zustand/react/shallow';
import { SourcingSharedCustomizeMessageStep } from 'modules/sourcing-shared/shared-steps/SourcingSharedCustomizeMessageStep';
import { getSourcingInternalHeaderBreadcrumbs } from 'modules/sourcing-internal/utils';
import { Channels } from 'generated-graphql/types';
import { useRecoilValue } from 'recoil';
import { integrationAtom } from 'services/integration/atom';
import { usePortalUrl } from 'modules/portal/hooks/usePortalUrl';

export const SourcingInternalCustomizeMessageStep = () => {
  const {
    sessionId,
    candidateBatch,
    selectedCandidateProfiles,
    editedOpeningMessage,
    customizeMessageFormData,
    applicationFormData,
    jobInformationFormData,
    defaultStartingTemplatedMessage,
    isDefaultStartingTemplatedMessageLoading,
    channelFormData,
    onCustomizeMessageBack,
    onCustomizeMessageNext,
    onCustomizeMessageInviteSubmit,
    setStep
  } = useSourcingInternalStore(
    useShallow((state) => ({
      sessionId: state.sessionId,
      candidateBatch: state.candidateBatch,
      selectedCandidateProfiles: state.selectedCandidateProfiles,
      editedOpeningMessage: state.editedOpeningMessage,
      customizeMessageFormData: state.customizeMessageFormData,
      applicationFormData: state.applicationFormData,
      jobInformationFormData: state.jobInformationFormData,
      isDefaultStartingTemplatedMessageLoading:
        state.isDefaultStartingTemplatedMessageLoading,
      channelFormData: state.channelFormData,
      defaultStartingTemplatedMessage: state.defaultStartingTemplatedMessage,
      onCustomizeMessageBack: state.onCustomizeMessageBack,
      onCustomizeMessageNext: state.onCustomizeMessageNext,
      onCustomizeMessageInviteSubmit: state.onCustomizeMessageInviteSubmit,
      setStep: state.setStep
    }))
  );

  const integrationCredentials = useRecoilValue(integrationAtom);
  const { portalUrl } = usePortalUrl({
    candidateBatchId: candidateBatch?.id ?? ''
  });

  const handleCustomizeMessageBack = () => {
    onCustomizeMessageBack({
      integrationCredentials,
      portalUrl
    });
  };

  return (
    <SourcingSharedCustomizeMessageStep
      headerBreadcrumbs={getSourcingInternalHeaderBreadcrumbs({
        candidateBatchJobTitle:
          candidateBatch?.jobDescriptionParsed?.jobTitle ?? '',
        candidateBatchId: candidateBatch?.id ?? '',
        setStep
      })}
      applicationFormData={applicationFormData}
      candidateBatchAtsJobId={!!candidateBatch?.atsJobId}
      candidateBatchAtsJobPostingUrl={candidateBatch?.atsJobPostingUrl}
      editedOpeningMessage={editedOpeningMessage}
      jobInformationFormData={jobInformationFormData}
      defaultStartingTemplatedMessage={defaultStartingTemplatedMessage}
      isDefaultStartingTemplatedMessageLoading={
        isDefaultStartingTemplatedMessageLoading
      }
      selectedRowLength={selectedCandidateProfiles?.length ?? 0}
      customizeMessageFormData={customizeMessageFormData}
      onCustomizeMessageBack={handleCustomizeMessageBack}
      onCustomizeMessageNext={(data) =>
        onCustomizeMessageNext({
          // Internal sourcing we use the first candidate profile in the list as the first candidate
          firstCandidateInListId:
            selectedCandidateProfiles?.[0]?.candidateProfile?.id ?? '',
          customizeMessageFormData: data
        })
      }
      onCustomizeMessageInviteSubmit={(formData) =>
        onCustomizeMessageInviteSubmit({
          customizeMessageFormData: formData,
          payload: {
            // Internal sourcing uses searchCandidateProfileSelectedId (sessionId)
            type: 'internal',
            searchCandidateProfileSelectedId: sessionId ?? ''
          }
        })
      }
      channelType={channelFormData?.channel ?? Channels.Email}
    />
  );
};
